export function getAuditReportsPath() {
  return '/pruefungsberichte'
}
